import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=769efa7d&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769efa7d')) {
      api.createRecord('769efa7d', component.options)
    } else {
      api.reload('769efa7d', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=769efa7d&", function () {
      api.rerender('769efa7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-210DrHm22OsEz/JS/cancellationPolicy.vue"
export default component.exports